import { render } from "./wDateRange.vue?vue&type=template&id=1145a2dc&ts=true"
import script from "./wDateRange.vue?vue&type=script&lang=ts"
export * from "./wDateRange.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__